import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from './context/AuthProvider';
import "./index.css";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AuthProvider>
      <BrowserRouter>
      <App />
  </BrowserRouter>
    </AuthProvider>
);
